/*
 * @Description: 新增爆料
 * @Author: jiang.weiwei
 * @LastEditors: pu.yuchun
 * @Date: 2017-12-12 17:19:48
 * @LastEditTime: 2019-10-28 13:26:07
 */
"use strict";
angular.module("createExplosionModule", []).controller("createExplosionCtrl", [
  "$scope",
  "$element",
  "$validation",
  "$q",
  "$modalInstance",
  "content",
  "item",
  "Upload",
  "httpService",
  "modalDialog",
  "$sce",
  "$interval",
  "$timeout",
  function (
    $scope,
    $element,
    $validation,
    $q,
    $modalInstance,
    content,
    item,
    Upload,
    httpService,
    modalDialog,
    $sce,
    $interval,
    $timeout
  ) {
    initStatus();
    initData();

    function initStatus() {
      $scope.srcVideo = "";
      $scope.videoId = "";
      $scope.status = {
        libType_v: 101, //视屏稿件的libtype
        libType_a: 201, //音频稿的libtype
        switch: "picture",
        articleContent: "",
        wordCount: 0, // 内容字数
        ing: false,
        error: false,
        success: false,
        typeMap: {
          picture: "图片",
          video: "视频",
          audio: "音频",
        },
        curType: "picture",
        uploadVideoUrl: "", //媒资视屏上传的地址
        uploadAudioUrl: "", //媒资音频上传的地址
        picSizeLimit: "", //图片上传的最大限制
      };
      $scope.data = {
        result: [],
        vresult: [],
        aresult: [],
        name: [],
        imgTitle: "上传图片",
        successList: [],
      };
      $scope.item = item; // 是否是编辑状态，默认是新建
      // loadUploadVideoIframe();
      // loadUploadAudioIframe();
    }

    function initData() {
      getPicSizeLimit();
      // 请求编辑信息
      if ($scope.item) {
        var params = {
          id: $scope.item.id,
        };
        httpService
          .http("/mcnww/web/article/findBrokeById.do", params, "get")
          .then(function (data) {
            $scope.data.result = data.picUrlList;
            $scope.data.aresult = data.audioUrlList;
            $scope.data.vresult = data.videoUrlList;
            if ($scope.data.vresult.length > 0) {
              $scope.status.videoName = $scope.data.vresult[0].fileName;
              $scope.ProgressBar = 100;
              $scope.status.transcoding = false;
              $scope.status.success = true;
              $scope.status.error = false;
              $scope.playVideo = $scope.data.vresult[0].url;
            }
            if ($scope.data.aresult.length > 0) {
              $scope.status.audioName = $scope.data.aresult[0].fileName;
              $scope.ProgressBar2 = 100;
              $scope.status.transcoding2 = false;
              $scope.status.success2 = true;
              $scope.status.error2 = false;
              $scope.playAudio = $scope.data.aresult[0].url;
            }
            $scope.data.result.map(function (item) {
              item.FILEINFO = "上传成功";
              item.success = true;
              return item;
            });
            $scope.status.articleContent = data.data.articleContent;
            $scope.status.wordCount = data.data.articleWordsCount;
          });
      }
    }
    /**
     * [clearVideoEventListener description] 清除视频监听服务
     * @return {[type]} [description]
     */
    function clearVideoEventListener() {
      if (angular.isFunction(videotheEvent)) {
        window.removeEventListener("message", videotheEvent, false);
      }
    }
    /**
     * [clearAudioEventListener description] 清除音频监听服务
     * @return {[type]} [description]
     */
    function clearAudioEventListener() {
      if (angular.isFunction(audiotheEvent)) {
        window.removeEventListener("message", audiotheEvent, false);
      }
    }
    $scope.confirm = function () {
      clearallVtimeout();
      clearallAtimeout();
      explosionSub(true);
    };
    /**
     * @description: 保存爆料到个人爆料
     * @param {type}
     * @return:
     */
    $scope.save = function () {
      explosionSub(false);
    };

    /**
     * @description: 提交爆料
     * @param {bPub} 是否发布
     * @return:
     */
    function explosionSub(bPub) {
      validator().then(function () {
        if ($scope.data.result.length > 0) {
          var flag = false;
          for (var i in $scope.data.result) {
            var result = $scope.data.result[i];
            if (!result.success) {
              flag = true;
              break;
            }
          }
          if (flag) {
            // modalDialog.alertType("", "您还有图片未上传成功", "warning", "confirm");
            modalDialog.success(
              "您还有图片未上传成功",
              "success",
              false,
              function () {},
              function () {},
              "",
              "getCodeSuccess"
            );
            return;
          }
        }
        var picList = $scope.data.result.map(function (item) {
          return (
            item.fileName +
            ":" +
            item.title +
            ":" +
            item.url +
            ":" +
            item.thumFileName || 'undefined'
          );
        });
        picList = picList.join(",");
        var params = {
          id: $scope.item ? $scope.item.id : "",
          articleType: 1,
          articleContent: $scope.status.articleContent,
          articleHtmlCon: $scope.status.articleContent,
          pictureIds: picList, //$scope.status.picInformation + '',
          bPub: bPub,
          qiniuIds: "",
          DOCWORDSCOUNT: $scope.status.wordCount,
        };
        if ($scope.switchMain == "video") {
          //   params.pictureIds = "";
          //   params.yunshiIds = vaList;
          //   picList = picList.join(",");
          // params.qiniuIds = $scope.videoId + ':3';
          //   params.qiniuIds = $scope.videoId + ":101";
          if (
            Number($scope.ProgressBar) >= 0 &&
            Number($scope.ProgressBar) < 100
          ) {
            modalDialog.alertType(
              "",
              "正在上传中，等待上传结束",
              "warning",
              "confirm"
            );
            return;
          } else if ($scope.status.transcoding == true) {
            modalDialog.alertType(
              "",
              "正在处理，等待处理成功",
              "warning",
              "confirm"
            );
            return;
          } else if ($scope.playVideo == undefined) {
            modalDialog.alertType(
              "",
              "处理失败请重新上传",
              "warning",
              "confirm"
            );
            return;
          } else if ($scope.playVideo == false) {
            params.qiniuIds = "";
          }
        } else if ($scope.switchMain == "audio") {
          //   params.pictureIds = "";
          // params.qiniuIds = $scope.audioId + ':2';
          //   params.qiniuIds = $scope.audioId + ":201";
          if (
            Number($scope.ProgressBar2) >= 0 &&
            Number($scope.ProgressBar2) < 100
          ) {
            modalDialog.alertType(
              "",
              "正在上传中，等待上传结束",
              "warning",
              "confirm"
            );
            return;
          } else if ($scope.status.transcoding2 == true) {
            modalDialog.alertType(
              "",
              "正在处理，等待处理成功",
              "warning",
              "confirm"
            );
            return;
          } else if ($scope.playAudio == undefined) {
            modalDialog.alertType(
              "",
              "处理失败请重新上传",
              "warning",
              "confirm"
            );
            return;
          } else if ($scope.playAudio == false) {
            params.qiniuIds = "";
          }
        }
        if ($scope.data.aresult.length) {
          var aList = $scope.data.aresult.map(function (item) {
            return {
              type: 2,
              originName: item.fileName,
              uploadName: item.title,
              uploadPath: item.url,
              thumbImg: "",
              audioVideoId: "",
            };
          });
        }
        if ($scope.data.vresult.length) {
          var vaList = $scope.data.vresult.map(function (item) {
            return {
              type: 3,
              originName: item.fileName,
              uploadName: item.title,
              uploadPath: item.url,
              thumbImg: "",
              audioVideoId: "",
            };
          });
        }
        if (aList && vaList) {
          params.yunshiIds = vaList.concat(aList);
        } else if (aList && !vaList) {
          params.yunshiIds = aList;
        } else if (vaList && !aList) {
          params.yunshiIds = vaList;
        }
        //   params.yunshiIds = vaList.concat(aList);
        params.yunshiIds = JSON.stringify(params.yunshiIds);
        httpService
          .http("/mcnww/web/article/addEdit.do", params, "post")
          .then(function (data) {
            $modalInstance.close();
            if (bPub) {
              modalDialog.success("发布成功", "info");
            } else {
              modalDialog.success("保存成功", "info");
            }
            $scope.deletevideo();
            $scope.deleteaudio();
          });
      });
    }

    $scope.cancel = function () {
      if ($scope.status.articleContent.length > 0) {
        modalDialog.confirmModal(
          "关闭",
          "关闭后编辑内容将会清空！",
          function () {
            $modalInstance.dismiss();
            clearallVtimeout();
            clearallAtimeout();
          },
          function () {}
        );
      } else {
        clearallVtimeout();
        clearallAtimeout();
        $modalInstance.dismiss();
      }
    };
    /**
     * [numberOfWord description] 正文字数计算
     * @return {[type]} [description]
     */
    $scope.numberOfWord = function () {
      $scope.status.wordCount = $scope.status.articleContent
        .replace(/\n/g, "")
        .replace(/ /g, "").length;
      return $scope.status.wordCount;
    };
    $scope.switch = function (type) {
      if ($scope.status.curType == type) {
        return;
      }
      $scope.status.switch = type;
      $scope.switchMain = $scope.status.switch;
      $scope.status.curType = type;
      if ($scope.status.success) {
        $(".speed")
          .find(".exhibition")
          .css("width", $scope.ProgressBar * 0.75 + "%");
      }
      if ($scope.status.success2) {
        $(".speed2")
          .find(".exhibition")
          .css("width", $scope.ProgressBar2 * 0.75 + "%");
      }
      //   if (
      //     $scope.data.result.length != 0 ||
      //     $scope.ProgressBar != undefined ||
      //     $scope.ProgressBar2 != undefined
      //   ) {
      //     modalDialog.confirmModal(
      //       "上传" + $scope.status.typeMap[type],
      //     //   "是否保留上传" + $scope.status.typeMap[$scope.status.curType] + "?",
      //     "是否保留此次上传的图片视频或者音频?",
      //       function () {
      //         // $scope.data.result = [];
      //         // $scope.deletevideo();
      //         // $scope.deleteaudio();
      //         // loadUploadVideoIframe();
      //         $scope.status.switch = type;
      //         $scope.switchMain = $scope.status.switch;
      //         $scope.status.curType = type;
      //       },
      //         function () {
      //             clearVideoEventListener(); //清除视频监听
      //             clearAudioEventListener(); //清除音频监听
      //             $scope.data.result = [];
      //             $scope.deletevideo();
      //             $scope.deleteaudio();
      //             // loadUploadVideoIframe();
      //             $scope.status.switch = type;
      //             $scope.switchMain = $scope.status.switch;
      //             $scope.status.curType = type;
      //       }
      //     );
      //   } else {
      //     $scope.data.result = [];
      //     $scope.deletevideo();
      //     $scope.deleteaudio();
      //     // loadUploadVideoIframe();
      //     $scope.status.switch = type;
      //     $scope.switchMain = $scope.status.switch;
      //     $scope.status.curType = type;
      //   }
    };
    /**
     * [validator description] 文本输入框格式校验
     * @return {[type]} [description]
     */
    function validator() {
      var deffer = $q.defer();
      $validation
        .validate($scope.createForm)
        .success(function () {
          if ($scope.numberOfWord() === 0) {
            modalDialog.alertType("", "正文内容不能为空", "warning", "confirm");
          } else {
            deffer.resolve();
          }
        })
        .error(function () {
          angular.invalidPosition($scope.createForm, $element);
        });
      return deffer.promise;
    }
    /**
     * [uploadPic description]  上传图片
     * @param  {[type]} files    [description]
     * @param  {[type]} file     [description]
     * @param  {[type]} newFiles [description]
     * @return {[type]}          [description]
     */
    $scope.uploadPic = function (files, file, newFiles) {
      if (!file) return;
      if ($scope.data.result.length + newFiles.length > 9) {
        // modalDialog.alertType("", "最多上传九张图片", "warning", "confirm");
        modalDialog.success(
          "最多上传九张图片",
          "success",
          false,
          function () {},
          function () {},
          "",
          "getCodeSuccess"
        );
        return;
      }
      let warnOnce = false;
      for (let i = newFiles.length - 1; i >= 0; i--) {
        if (newFiles[i].size / 1024 / 1024 > $scope.status.picSizeLimit) {
          warnOnce = true;
          newFiles.splice(i, 1);
        }
      }
      if (warnOnce) {
        modalDialog.alertType("", `图片超过20M`, "warning", "confirm");
      }
      if (newFiles.length != 0) {
        newFiles = packagePicList(newFiles);
        angular.forEach(newFiles, function (file, index) {
          if ($scope.data.result[index].success) return;
          Upload.upload({
            url: "/mcnww/upload/image.do",
            headers: { requestToken: sessionStorage.getItem("requestToken") },
            data: {
              file: newFiles[index],
            },
          }).then(
            function (resp) {
              if (resp.data.success) {
                $timeout(function () {
                  $scope.data.result[index].FILEINFO = "上传成功";
                  $scope.data.result[index].title = resp.data.title;
                  $scope.data.result[index].imgSrc =
                    angular.globalConfig.pictureServer + resp.data.url;
                  $scope.data.result[index].fileName = resp.data.fileName;
                  $scope.data.result[index].success = true;
                  $scope.data.result[index].url = resp.data.url;
                  $scope.data.result[index].thumFileName =
                    resp.data.thumFileName;
                }, 10);
              } else {
                $timeout(function () {
                  if (
                    resp.data.state ==
                    "上传文件的大小超出限制,最大不能超过5120KB"
                  ) {
                    $scope.data.result[index].FILEINFO = "图片超出5M";
                  } else if (resp.data.state == "非法的文件类型") {
                    $scope.data.result[index].FILEINFO = "非法文件类型";
                  } else {
                    $scope.data.result[index].FILEINFO = "上传失败";
                  }
                  $scope.data.result[index].error = resp.data.success;
                }, 10);
              }
            },
            function (resp) {
              $timeout(function () {
                $scope.data.result[index].FILEINFO = "上传失败";
                if (resp.status == "502") {
                  $scope.data.result[index].error = "文件太大，不得大于5MB!";
                } else {
                  $scope.data.result[index].error = "未知错误!";
                }
              }, 10);
            },
            function (evt) {
              $timeout(function () {
                $scope.data.result[index].progress =
                  parseInt((100.0 * evt.loaded) / evt.total) + "%";
                $scope.data.result[index].progressStyle = {
                  width: $scope.data.result[index].progress,
                };
              });
            }
          );
        });
      }
    };
    /**
     * [freshPic description] 刷新图片
     * @return {[type]} [description]
     */
    $scope.freshPic = function ($newFiles, item) {
      delete item.error;
      delete item.FILEINFO;
      Upload.upload({
        url: "/mcnadmin/upload/image.do",
        headers: { requestToken: sessionStorage.getItem("requestToken") },
        data: {
          file: $newFiles[0],
        },
      }).then(
        function (resp) {
          if (resp.data.success) {
            $timeout(function () {
              item.FILEINFO = "上传成功";
              item.title = resp.data.title;
              item.imgSrc = angular.globalConfig.pictureServer + resp.data.url;
              item.fileName = resp.data.fileName;
              item.success = true;
              item.url = resp.data.url;
              item.thumFileName = resp.data.thumFileName;
            }, 10);
          } else {
            $timeout(function () {
              item.FILEINFO = "上传失败";
              item.error = resp.data.success;
            }, 10);
          }
        },
        function (resp) {
          $timeout(function () {
            item.FILEINFO = "上传失败";
            if (resp.status == "502") {
              item.error = "文件太大，不得大于20MB!";
            } else {
              item.error = "未知错误!";
            }
          }, 10);
        },
        function (evt) {
          $timeout(function () {
            item.progress = parseInt((100.0 * evt.loaded) / evt.total) + "%";
            item.progressStyle = {
              width: item.progress,
            };
          });
        }
      );
    };
    /**
     * [packagePicList description] 组装图片列表
     * @return {[type]} [description]
     */
    function packagePicList(files, type) {
      var tempFiles;
      if (type == 3) {
        tempFiles = $scope.data.vresult.concat(files);
      } else if (type == 2) {
        tempFiles = $scope.data.aresult.concat(files);
      } else {
        tempFiles = $scope.data.result.concat(files);
      }

      for (var i in files) {
        var file = files[i];
        var obj = {
          original: file, //把原始的file保存起来
          imgSrc: URL.createObjectURL(file),
          display: "inline-block",
        };
        if (type == 3) {
          $scope.data.vresult.push(obj);
        } else if (type == 2) {
          $scope.data.aresult.push(obj);
        } else {
          $scope.data.result.push(obj);
        }
      }
      return tempFiles;
    }

    /** [deleteItem description]选择不想上传的图片进行删除 */
    $scope.deleteItem = function (index) {
      $scope.data.result.splice(index, 1);
    };
    /**
     * [getPicSizeLimit description] 获取图片尺寸上限
     * @return {[type]} [description]
     */
    function getPicSizeLimit() {
      httpService
        .http("/mcnww/web/image/getImageSizelimit.do", "", "get")
        .then(function (data) {
          $scope.status.picSizeLimit = Number(data.data) / 1024;
        });
    }
    /**
     * [loadUploadVideoIframe description] 加载上传视频的iframe
     * @return {[type]} [description]
     */
    function loadUploadVideoIframe() {
      $.ajax({
        url: "/mcnww/web/cloud/videoUpload.do",
        type: "post",
        headers: { requestToken: sessionStorage.getItem("requestToken") },
        data: "",
        datatype: "text",
        success: function (data) {
          var urlarr = data.split("/");
          urlarr.splice(0, 3);
          $scope.srcVideo = "/" + urlarr.join("/");

          // data = data.replace(/http:\/\/testqiniu.tmuyun.com:8080/, "");
          // $scope.srcVideo = data;
          // $scope.status.uploadVideoUrl = data.split("?")[0];
          $scope.srcVideo = $sce.trustAsResourceUrl($scope.srcVideo);
        },
      });
    }
    /**
     * [loadUploadAudioIframe description] 加载音频的iframe
     * @return {[type]} [description]
     */
    function loadUploadAudioIframe() {
      $.ajax({
        url: "/mcnww/web/cloud/audioUpload.do",
        type: "post",
        headers: { requestToken: sessionStorage.getItem("requestToken") },
        data: "",
        datatype: "text",
        success: function (data) {
          var urlarr = data.split("/");
          urlarr.splice(0, 3);
          $scope.srcAudio = "/" + urlarr.join("/");

          // data = data.replace(/http:\/\/testqiniu.tmuyun.com:8080/, "");
          // $scope.srcAudio = data;
          // $scope.status.uploadAudioUrl = data.split("?")[0];
          $scope.srcAudio = $sce.trustAsResourceUrl($scope.srcAudio);
        },
      });
    }
    /**
     * [uploadVideo description]初始化上传至吉木萨尔县在线的视频的方法
     * @return {[type]} [description]
     */
    $scope.uploadVideo = function (files, file, newFiles) {
      if (!file) return;
      // 大于200MB给个提示
      if (file.size > 209715200) {
        modalDialog.alertType(
          "上传失败",
          "请选择小于200MB的视频，再上传！",
          "warning",
          "confirm"
        );
        return;
      }
      if (newFiles.length != 0) {
        newFiles = packagePicList(newFiles, 3);
        angular.forEach(newFiles, function (file, index) {
          if ($scope.data.vresult[index].success) return;
          Upload.upload({
            url: "/mcnww/upload/video.do",
            headers: { requestToken: sessionStorage.getItem("requestToken") },
            data: {
              file: newFiles[index],
            },
          }).then(
            function (resp) {
              if (resp.data.success) {
                $scope.data.vresult[index] = resp.data;
                $scope.vuploadsuccess = $timeout(function () {
                  $scope.status.videoName = resp.data.title;
                  // $scope.ProgressBar = undefined;
                  $scope.status.transcoding = false;
                  $scope.status.success = true;
                  $scope.status.error = false;
                  $scope.playVideo = resp.data.url;
                }, 10);
              } else {
                $scope.vuploadfail = $timeout(function () {
                  $scope.status.videoName = "上传失败";
                  $scope.status.transcoding = false;
                  $scope.status.success = false;
                  $scope.status.error = true;
                  $scope.playVideo = false;
                }, 10);
                $(".speed")
                .find(".exhibition")
                .css("width","0%");
              }
            },
            function (resp) {
              $scope.vuploadfail2 = $timeout(function () {
                $scope.status.videoName = "上传失败";
                $scope.status.transcoding = false;
                $scope.status.success = false;
                $scope.status.error = true;
                $scope.playVideo = false;
              }, 10);
              $(".speed")
              .find(".exhibition")
              .css("width","0%");
            },
            function (evt) {
              $scope.vuploadjindu = $timeout(function () {
                $scope.ProgressBar = parseInt((100.0 * evt.loaded) / evt.total);
                // $scope.progressStyle = {
                //     width: $scope.ProgressBar
                // };
                $scope.status.transcoding = true;
                $scope.status.error = false;
                $(".speed")
                  .find(".exhibition")
                  .css("width", $scope.ProgressBar * 0.75 + "%");
              });
            }
          );
        });
      }
    };

    function uploadVideo() {
      videoeventListener(); //视频启动监听
      // document.getElementById("explosionVideo").contentWindow.postMessage('upload', $scope.status.uploadVideoUrl);
      document
        .getElementById("explosionVideo")
        .contentWindow.postMessage("upload", "/");
    }
    /**
     * [uploadAudio description]初始化上传至吉木萨尔县在线的音频的方法
     * @return {[type]} [description]
     */
    $scope.uploadAudio = function (files, file, newFiles) {
      // uploadAudio();
      if (!file) return;
      if (newFiles.length != 0) {
        newFiles = packagePicList(newFiles, 2);
        angular.forEach(newFiles, function (file, index) {
          if ($scope.data.aresult[index].success) return;
          Upload.upload({
            url: "/mcnww/upload/audio.do",
            headers: { requestToken: sessionStorage.getItem("requestToken") },
            data: {
              file: newFiles[index],
            },
          }).then(
            function (resp) {
              if (resp.data.success) {
                $scope.data.aresult[index] = resp.data;
                $scope.auploadsuccess = $timeout(function () {
                  $scope.status.audioName = resp.data.title;
                  // $scope.ProgressBar2 = undefined;
                  $scope.status.transcoding2 = false;
                  $scope.status.success2 = true;
                  $scope.status.error2 = false;
                  $scope.playAudio = resp.data.url;
                }, 10);
              } else {
                $scope.auploadfail = $timeout(function () {
                  $scope.status.audioName = "上传失败";
                  $scope.status.transcoding2 = false;
                  $scope.status.success2 = false;
                  $scope.status.error2 = true;
                  $scope.playAudio = false;
                }, 10);
                $(".speed2")
                  .find(".exhibition")
                  .css("width","0%");
              }
            },
            function (resp) {
              $scope.auploadfail2 = $timeout(function () {
                $scope.status.audioName = "上传失败";
                $scope.status.transcoding2 = false;
                $scope.status.success2 = false;
                $scope.status.error2 = true;
                $scope.playAudio = false;
              }, 10);
              $(".speed2")
                  .find(".exhibition")
                  .css("width","0%");
            },
            function (evt) {
              $scope.auploadjindu = $timeout(function () {
                $scope.ProgressBar2 = parseInt(
                  (100.0 * evt.loaded) / evt.total
                );
                // $scope.progressStyle = {
                //     width: $scope.ProgressBar
                // };
                $scope.status.transcoding2 = true;
                $scope.status.error2 = false;
                $(".speed2")
                  .find(".exhibition")
                  .css("width", $scope.ProgressBar2 * 0.75 + "%");
              });
            }
          );
        });
      }
    };

    /**
     * [clearalltimeout description]清除所有音频定时器
     *
     * @return  {[type]}  [return description]
     */
    function clearallAtimeout() {
      $timeout.cancel($scope.auploadsuccess);
      $timeout.cancel($scope.auploadjindu);
      $timeout.cancel($scope.auploadfail2);
      $timeout.cancel($scope.auploadfail);
    }

        /**
     * [clearalltimeout description]清除所有视频定时器
     *
     * @return  {[type]}  [return description]
     */
    function clearallVtimeout() {
      $timeout.cancel($scope.vuploadsuccess);
      $timeout.cancel($scope.vuploadjindu);
      $timeout.cancel($scope.vuploadfail2);
      $timeout.cancel($scope.vuploadfail);
    }

    function uploadAudio() {
      audioeventListener(); //视频启动监听
      // document.getElementById("explosionAudio").contentWindow.postMessage('upload', $scope.status.uploadAudioUrl);
      document
        .getElementById("explosionAudio")
        .contentWindow.postMessage("upload", "/");
    }

    /**
     * [refresh description] 重新上传视频
     * @return {[type]} [description]
     */
    $scope.refreshvideo = function () {
      $scope.deletevideo();
      clearallVtimeout();
      $timeout(function () {
        // uploadVideo();
        $("#videoContentAdd1").click();
      }, 200);
    };
    /**
     * [deleteVideo description] 删除视频
     * @return {[type]} [description]
     */
    $scope.deletevideo = function () {
      clearallVtimeout();
      // document.getElementById("explosionVideo").contentWindow.postMessage('delete', $scope.status.uploadVideoUrl);
      document
        .getElementById("explosionVideo")
        .contentWindow.postMessage("delete", "/");
      clearVideoEventListener(); //清除视频监听
      // loadUploadVideoIframe();
      $scope.status.videoName = "";
      $scope.ProgressBar = undefined;
      $scope.status.transcoding = false;
      $scope.status.success = false;
      $scope.status.error = false;
      $scope.playVideo = false;
      $scope.data.vresult = [];
      $scope.videoId = ""; //清空点击发布按钮是，要上传的视频的ID
    };
    /**
     * [refreshAudio description] 重新上传音频
     * @return {[type]} [description]
     */
    $scope.refreshAudio = function () {
      $scope.deleteaudio();
      clearallAtimeout();
      $timeout(function () {
        // $scope.uploadAudio();
        $("#videoContentAdd2").click();
      }, 200);
    };
    /**
     * [deleteaudio description] 删除音频
     * @return {[type]} [description]
     */
    $scope.deleteaudio = function () {
      // document.getElementById("explosionAudio").contentWindow.postMessage('delete', $scope.status.uploadAudioUrl);
      document
        .getElementById("explosionAudio")
        .contentWindow.postMessage("delete", "/");
      clearVideoEventListener(); //清除音频监听
      clearallAtimeout();
      // loadUploadVideoIframe();
      $scope.status.audioName = "";
      $scope.ProgressBar2 = undefined;
      $scope.status.transcoding2 = false;
      $scope.status.success2 = false;
      $scope.status.error2 = false;
      $scope.playAudio = false;
      $scope.data.aresult = [];
      $scope.audioId = ""; //清空点击发布按钮是，要上传的视频的ID
    };
    /**
     * [videoeventListener description] postMessage视频信息监听
     * @return {[type]} [description]
     */
    function videoeventListener() {
      clearVideoEventListener(); //先清除
      //保存视频
      window.addEventListener("message", videotheEvent, false);
    }
    /**
     * [audioeventListener description] postMessage音频信息监听
     * @return {[type]} [description]
     */
    function audioeventListener() {
      clearAudioEventListener(); //先清除
      //保存视频
      window.addEventListener("message", audiotheEvent, false);
    }

    /**
     * [videotheEvent description] 视频监听事件方法
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    function videotheEvent(e) {
      if (!!e && angular.isString(e.data) && e.data.indexOf("video") > -1) {
        var msg = e.data;
        //判断是否是正确格式
        if (msg.indexOf("progress") > -1) {
          $timeout(function () {
            $scope.ProgressBar = e.data.split("=")[1];
            $(".speed")
              .find(".exhibition")
              .css("width", $scope.ProgressBar * 0.75 + "%");
          });
        } else if (msg.indexOf("complete") > -1) {
          var vId = e.data.split("=")[1];
          $scope.status.transcoding = true;
          saveVideo(vId, $scope.status.libType_v).then(function (data) {
            if (data.code == 0) {
              videotimer(vId);
            }
          });
        } else if (msg.indexOf("type") > -1) {
          modalDialog.alertType(
            "上传失败",
            "请选择正确的视频格式，再上传！",
            "warning",
            "confirm",
            function () {
              $scope.deletevideo();
            }
          );
          return;
        }
      }
    }
    /**
     * [saveVideo description] 保存音视屏
     * @param  {[type]} dataId [description]
     * @return {[type]}        [description]
     */
    function saveVideo(vId, libType) {
      var deffer = $q.defer();
      httpService
        .http(
          "/mcnww/web/cloud/saveVideo.do",
          { id: vId, libType: libType },
          "get"
        )
        .then(function (data) {
          deffer.resolve(data);
        });
      return deffer.promise;
    }
    /**
     * [videotimer description] 视频定时刷新
     * @param  {[type]} dataId [description]
     * @return {[type]}        [description]
     */
    function videotimer(vId) {
      var timer = $interval(function () {
        httpService
          .http(
            "/mcnww/web/cloud/getVideoStatus.do",
            { id: vId, libType: $scope.status.libType_v },
            "get"
          )
          .then(function (data) {
            if (data.code === 0) {
              if (data.data.code === 0) {
                $interval.cancel(timer);
                downLoadVideo(vId);
                $timeout(function () {
                  $scope.status.transcoding = false;
                });
              }
            }
          });
      }, 5000);
    }
    /**
     * [audiotheEvent description] 音频监听事件方法
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    function audiotheEvent(e) {
      if (!!e && angular.isString(e.data) && e.data.indexOf("audio") > -1) {
        var msg = e.data;
        //判断是否是正确格式
        if (msg.indexOf("progress") > -1) {
          $timeout(function () {
            $scope.ProgressBar2 = e.data.split("=")[1];
            $(".speed2")
              .find(".exhibition")
              .css("width", $scope.ProgressBar2 * 0.75 + "%");
          });
        } else if (msg.indexOf("complete") > -1) {
          var vId = e.data.split("=")[1];
          $scope.status.transcoding2 = true;
          //              audiotimer(vId);

          // downLoadAudio(vId);
          saveVideo(vId, $scope.status.libType_a).then(function (data) {
            if (data.code == 0) {
              audiotimer(vId);
            }
          });
        } else if (msg.indexOf("type") > -1) {
          modalDialog.alertType(
            "上传失败",
            "请选择正确的音频格式，再上传！",
            "warning",
            "confirm",
            function () {
              $scope.deleteaudio();
            }
          );
          return;
        }
      }
    }
    /**
     * [audiotimer description] 音频定时刷新
     * @param  {[type]} dataId [description]
     * @return {[type]}        [description]
     */
    function audiotimer(vId) {
      var timer = $interval(function () {
        httpService
          .http(
            "/mcnww/web/cloud/getVideoStatus.do",
            { id: vId, libType: $scope.status.libType_a },
            "get"
          )
          .then(function (data) {
            if (data.code === 0) {
              if (data.data.code === 0) {
                $interval.cancel(timer);
                downLoadAudio(vId);
                $timeout(function () {
                  $scope.status.transcoding2 = false;
                });
              }
            }
          });
      }, 5000);
    }
    /**
     * [downLoadVideo description] 视频下载
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    function downLoadVideo(vId) {
      httpService
        .http(
          "/mcnww/web/cloud/getVideoUrl.do",
          { id: vId, libType: $scope.status.libType_v },
          "get"
        )
        .then(function (data) {
          $timeout(function () {
            $scope.playVideo = $sce.trustAsResourceUrl(data.data.videoUrl);
            if ($scope.playVideo == undefined) {
              $scope.status.success = false;
              $scope.status.error = true;
            } else {
              $scope.status.success = true;
              $scope.videoId = vId;
            }
          });
        });
    }
    /**
     * [downLoadAudio description] 音频下载
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    function downLoadAudio(vId) {
      httpService
        .http(
          "/mcnww/web/cloud/getVideoUrl.do",
          { id: vId, libType: $scope.status.libType_a },
          "get"
        )
        .then(function (data) {
          $timeout(function () {
            $scope.playAudio = $sce.trustAsResourceUrl(data.data.videoUrl);
            if ($scope.playAudio == undefined) {
              $scope.status.success2 = false;
              $scope.status.error2 = true;
            } else {
              $scope.status.success2 = true;
              $scope.audioId = vId;
            }
          });
        });
    }
    $scope.$on("$destroy", function () {
      clearallVtimeout();
      clearallAtimeout();
      clearVideoEventListener();
      clearAudioEventListener();
    });
  },
]);
